var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-table',{attrs:{"stripe":"","columns":_vm.columns,"data":_vm.products}})
}
var staticRenderFns = []

export { render, staticRenderFns }